export default function copyright() {
  return {
    _id: false,
    type: 'droplet.copyright',
    text: 'You Org Name',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/copyright/droplet.schema.js